import CartModalController from "emun.cart/cart-modal.controller.es6";
import shoppingConfig from "emun.shopping/shopping.config";

export default class CreateCartPromptController extends CartModalController {
  constructor($session, $cart, $uibModalInstance, options) {
    super($session, $cart, $uibModalInstance, options);
    let $ctrl = this;

    $ctrl.request = {
      cartName: options.cartName || shoppingConfig.generateCartName(),
      type: options.type || "",
      businessModel: $session.businessModel,
      purchaser: {
        id:
          options.purchaserId ||
          options.retailerId ||
          $session.retailerId ||
          ($session.businessModel === "Retail" && $session.userAuthId)
      }
    };
  }

  findRetailers(val) {
    let $ctrl = this;
    let url = `BrowseRetailers.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`; //
    console.log("findRetailers.$item", url);
    return $ctrl.bus.send(url).then(res => res.data.results);
  }

  submit() {
    let $ctrl = this;
    return $ctrl.$cart
      .createCart($ctrl.request)
      .then(cart => $ctrl.$close(cart));
  }
}
